import React, { PropTypes } from 'react';
import FaqList from 'common/components/faqs';
import { v4 } from 'node-uuid';
import classnames from 'classnames';

const Faq = ({ questions, title, className, background }) => (
  <div key={v4()} className={classnames('block block-faqs thick', className, background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{ title }</h2>
      </div>
    </div>
    <div className="row align-center">
      <div className="small-16 medium-10 columns">
        <FaqList data={questions} />
      </div>
    </div>
  </div>
);

Faq.propTypes = {
  questions: PropTypes.array,
  title: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.string,
};

export default Faq;
